import { FdDown, FdRight } from '@qodly/icons';
import { FC, MouseEventHandler } from 'react';
import cn from 'classnames';

const Switcher: FC<{
  show: boolean;
  expanded: boolean;
  variant?: 'arrow' | 'caret';
  onClick?: MouseEventHandler;
}> = ({ show, expanded, onClick, variant = 'arrow' }) => {
  if (!show) return <div className="flex h-6 w-3 items-center"></div>;
  return (
    <div
      className="flex h-6 w-5 items-center"
      onClick={(e) => onClick && onClick(e)}
    >
      {(() => {
        switch (variant) {
          case 'arrow':
            // return expanded ? <FdDown /> : <FdRight />;
            return (
              <FdDown
                className={cn([
                  'h-3 w-3 transform text-grey-50 transition ease-in-out',
                  {
                    'rotate-0': expanded,
                    '-rotate-90': !expanded,
                  },
                ])}
              />
            );
          case 'caret':
            return expanded ? <FdDown /> : <FdRight />;
          default:
            return (
              <FdDown className="h-3 w-3 transform text-grey-50 transition ease-in-out" />
            );
        }
      })()}
    </div>
  );
};

export default Switcher;
